import React from 'react';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import { PageObject } from 'shared/CommonInterface';
import { setVesselMasterPageURL } from 'Store/Generic/ReportingSlice';

interface PageNavButtonProps<T> {
    pageobj: PageObject<T>;
    setPageUrl?: (url: string) => void;
    pageUrl?: string;
    isLoading?: boolean;
    isFetching?: boolean;
}

const PageNavButton = <T,>({ pageobj, setPageUrl, pageUrl, isLoading = false, isFetching = false }: PageNavButtonProps<T>) => {
    const { VesselMasterPageURL } = useSelector((state: RootState) => state.Reporting);
    const dispatch = useDispatch();
    // Default currentPage to 1 if pageUrl is undefined or doesn't have 'page' parameter
    const currentPage = (() => {
        if (setPageUrl ? !pageUrl : !VesselMasterPageURL) return 1;
        const urlParams = new URLSearchParams((setPageUrl ? pageUrl : VesselMasterPageURL).split('?')[1]);
        return parseInt(urlParams.get('page') || '1', 10);
    })();
    // Calculate total pages based on total results and page size (10)
    const totalResults = pageobj?.count || 0;
    const totalPages = Math.ceil(totalResults / 10);

    // Return nothing if there is only one page or no pages
    if (totalPages <= 1 && !isFetching) return <>Total count: {totalResults}</>;

    return (
        <Row className="m-1">
            <Col xs="7">
                Page {currentPage} of {totalPages} <br />
                Total count: {totalResults || '0'}
            </Col>
            <Col xs="5" className='d-flex align-items-center justify-content-end'>
                <div className="btn-group float-end">
                    <Button
                        type="button"
                        color="success"
                        size="sm"
                        className="waves-effect"
                        disabled={!(pageobj?.previous) || isLoading || isFetching}
                        onClick={() => {
                            if (pageobj?.previous) setPageUrl ? setPageUrl(pageobj?.previous) : dispatch(setVesselMasterPageURL(pageobj?.previous));
                        }}
                    >
                        {!(isLoading || isFetching) || !(pageobj?.previous) ? (
                            <i className="fa fa-chevron-left" />
                        ) : (
                            <i className="bx bx-loader bx-spin" />
                        )}
                    </Button>
                    <Button
                        type="button"
                        color="success"
                        size="sm"
                        className="waves-effect ms-2"
                        disabled={!(pageobj?.next) || isLoading || isFetching}
                        onClick={() => {
                            if (pageobj?.next) setPageUrl ? setPageUrl(pageobj?.next) : dispatch(setVesselMasterPageURL(pageobj?.next));
                        }}
                    >
                        {!(isLoading || isFetching) || !(pageobj?.next) ? (
                            <i className="fa fa-chevron-right" />
                        ) : (
                            <i className="bx bx-loader bx-spin" />
                        )}
                    </Button>
                </div>
            </Col>
        </Row>
    );
};

export default PageNavButton;